import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]
const _hoisted_11 = ["fill"]
const _hoisted_12 = ["fill"]
const _hoisted_13 = ["fill"]
const _hoisted_14 = ["fill"]
const _hoisted_15 = ["fill"]
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["fill"]
const _hoisted_18 = ["fill"]
const _hoisted_19 = ["fill"]
const _hoisted_20 = ["fill"]
const _hoisted_21 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  name: 'HeumTaxLogo',
  props: {
    color: null,
    width: null,
    height: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width || 238,
    height: __props.height || 54,
    viewBox: "0 0 238 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M34.2263 0H18.8848V24.7456H34.2263V0Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M15.3416 0H0V53.0261H15.3416V0Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M53.1091 0H37.7676V53.0261H53.1091V0Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M34.2263 28.2808H18.8848V53.0264H34.2263V28.2808Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_5),
    _createElementVNode("path", {
      d: "M85.316 11.7231H81.9699V20.3022H76.6377V23.6432H81.9699V41.5988H85.316V23.6432V20.3022V11.7231Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_6),
    _createElementVNode("path", {
      d: "M90.9106 11.4414H87.5645V41.8559H90.9106V11.4414Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_7),
    _createElementVNode("path", {
      d: "M202.232 11.7231H198.886V21.617H194.374C193.079 20.453 191.352 19.6986 189.452 19.6986C185.394 19.6986 182.091 22.9966 182.091 27.049C182.091 31.1014 185.394 34.3993 189.452 34.3993C191.352 34.3993 193.057 33.6665 194.374 32.4809H198.886V41.5772H202.232V32.4809V29.1398V24.9581V21.617V11.7231ZM189.452 31.554C186.97 31.554 184.962 29.5494 184.962 27.0705C184.962 24.5917 186.97 22.587 189.452 22.587C191.935 22.587 193.942 24.5917 193.942 27.0705C193.942 29.5494 191.935 31.554 189.452 31.554ZM198.886 29.1614H196.49C196.684 28.4932 196.835 27.8034 196.835 27.0705C196.835 26.3376 196.706 25.6479 196.49 24.9797H198.886V29.1614Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_8),
    _createElementVNode("path", {
      d: "M207.827 11.4414H204.48V41.8559H207.827V11.4414Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_9),
    _createElementVNode("path", {
      d: "M141.948 17.714H136.875V21.0551H141.948V28.039H145.294V21.0551V17.714V11.4414H141.948V17.714Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_10),
    _createElementVNode("path", {
      d: "M173.176 11.4414H169.83V32.8889H173.176V11.4414Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_11),
    _createElementVNode("path", {
      d: "M141.946 32.8841H129.965V28.9395H126.619V42.0451H145.314V28.9395H141.968V32.8841H141.946ZM129.965 38.704V36.2467H141.946V38.704H129.965Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_12),
    _createElementVNode("path", {
      d: "M157.635 30.2788H154.289V42.048H156.254H157.635H173.848V38.7069H157.635V30.2788Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_13),
    _createElementVNode("path", {
      d: "M92.6426 32.2805H104.581V41.8726H107.927V32.2805H119.865V28.9395H92.6426V32.2805Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_14),
    _createElementVNode("path", {
      d: "M237.304 29.6091V26.2681H210.039V29.6091H221.999V31.5276H214.054L214.054 42.049H233.311L233.311 31.5276H225.366V29.6091H237.326H237.304ZM229.943 34.8902L229.943 38.7079H217.4L217.4 34.8902H221.999H225.345H229.943Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_15),
    _createElementVNode("path", {
      d: "M112.648 25.4539H115.995V11.7231H96.7383V25.4539H112.627H112.648ZM100.106 15.0642H112.648V22.1128H100.106V15.0642Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_16),
    _createElementVNode("path", {
      d: "M134.968 26.4885H136.026V11.7231H132.68V16.4438H124.606V11.7231H121.26V26.4885H134.99H134.968ZM124.584 23.1475V19.7848H132.658V23.1475H124.584Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_17),
    _createElementVNode("path", {
      d: "M190.859 18.4646H197.119V15.1235H190.859V10.9849H187.512V15.1235H181.23V18.4646H187.512H190.859Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_18),
    _createElementVNode("path", {
      d: "M164.57 19.7402C164.57 15.1489 160.857 11.4414 156.259 11.4414C151.66 11.4414 147.947 15.1489 147.947 19.7402C147.947 24.3315 151.66 28.039 156.259 28.039C160.857 28.039 164.57 24.3315 164.57 19.7402ZM150.905 19.7402C150.905 16.7871 153.301 14.3945 156.259 14.3945C159.216 14.3945 161.612 16.7871 161.612 19.7402C161.612 22.6933 159.216 25.0859 156.259 25.0859C153.301 25.0859 150.905 22.6933 150.905 19.7402Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_19),
    _createElementVNode("path", {
      d: "M223.682 25.814C228.064 25.814 231.626 22.516 231.626 18.4636C231.626 14.4112 228.064 11.1133 223.682 11.1133C219.299 11.1133 215.737 14.4112 215.737 18.4636C215.737 22.516 219.299 25.814 223.682 25.814ZM223.682 13.9801C226.358 13.9801 228.539 15.9848 228.539 18.4636C228.539 20.9425 226.358 22.9472 223.682 22.9472C221.005 22.9472 218.824 20.9425 218.824 18.4636C218.824 15.9848 221.005 13.9801 223.682 13.9801Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_20),
    _createElementVNode("path", {
      d: "M74.5909 24.7641H74.6125V11.7231H69.3882V15.0642H71.2664V24.7641H71.2879C70.5108 26.7256 68.719 29.808 64.79 32.4593L66.6682 34.9382C66.6682 34.9382 71.2448 31.554 72.9502 27.7387C74.6556 31.554 79.2322 34.9382 79.2322 34.9382L81.1104 32.4593C77.1814 29.8296 75.3896 26.7256 74.6125 24.7641H74.5909Z",
      fill: __props.color || 'white'
    }, null, 8, _hoisted_21)
  ], 8, _hoisted_1))
}
}

})